import React, { HTMLAttributes } from 'react'

export const MerifyResumeSvg = ({ className, ...props }: HTMLAttributes<HTMLOrSVGElement>) => {
	return (
		<svg
			width={440}
			height={384}
			viewBox='0 0 440 384'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`merify-resume${className ? ` ${className}` : ''}`}
			{...props}
		>
			<g clipPath='url(#clip0_1186_688)'>
				<path
					d='M313.12 285.62V92a5.572 5.572 0 00-5.56-5.57H132.83a5.58 5.58 0 00-5.57 5.57v193.62c0 1.477.587 2.894 1.631 3.939a5.574 5.574 0 003.939 1.631h174.73a5.56 5.56 0 005.56-5.57zm-11.13-5.57h-163.6V97.57h163.6v182.48z'
					fill='#110BE0'
				/>
				<path d='M288.82 249.69H154.48v11.14h134.34v-11.14z' fill='#110BE0' />
				<path
					d='M244.11 229.6c22.12 0 31.22-9.48 31.22-17.48 0-12.54-5.29-22.1-13.69-28.52a35.29 35.29 0 00-17.81-7.08c-2.19 4.71-12.82 9.1-22.67 9.18-10.44.11-20.07-4.3-21.74-9.18a35.23 35.23 0 00-17.88 7.15c-8.4 6.43-13.71 14.52-13.71 28.59 0 9.75 10.32 17.39 31.14 17.39l45.14-.05z'
					fill='#7F7FFF'
				/>
				<path
					d='M199 232.19c-24.84 0-33.7-10.31-33.7-19.95 0-13.39 4.52-22.83 14.64-30.62a37.755 37.755 0 0119.18-7.67 2.584 2.584 0 012.71 1.74c1.09 3.19 8.93 7.58 19.28 7.45 9.34-.08 18.78-4.28 20.37-7.7a2.568 2.568 0 012.59-1.47 37.856 37.856 0 0119.15 7.6c9.61 7.35 14.69 17.91 14.69 30.55 0 5.22-3.08 10.28-8.45 13.87-6 4-14.8 6.17-25.33 6.17l-45.13.03zm-1.08-52.92a32.68 32.68 0 00-14.86 6.4c-8.86 6.82-12.64 14.77-12.64 26.57 0 9.15 10.95 14.83 28.58 14.83h45.11c19.69 0 28.66-7.74 28.66-14.92 0-11-4.39-20.14-12.69-26.49a32.734 32.734 0 00-15-6.37c-4.12 5.36-15.12 8.92-23.94 9h-.43c-10.04-.03-19.39-3.81-22.79-9v-.02z'
					fill='#110BE0'
				/>
				<path
					d='M221.6 171.77a28.939 28.939 0 10-11.156-55.668A28.936 28.936 0 00192.6 142.84a29 29 0 0029 28.93z'
					fill='#7F7FFF'
				/>
				<path
					d='M221.6 174.33a31.502 31.502 0 01-22.189-53.798 31.5 31.5 0 0153.749 22.308 31.57 31.57 0 01-31.56 31.49zm0-57.87a26.377 26.377 0 00-24.329 16.326 26.387 26.387 0 005.757 28.729 26.38 26.38 0 0045.012-18.675 26.438 26.438 0 00-26.44-26.38zM439.05 214.46l-45.42-63.48-45.23 63.42h29.13c-11.04 77.18-77.56 136.69-157.7 136.69a157.633 157.633 0 01-72.39-17.34 160.861 160.861 0 01-55.11-46.4 16.199 16.199 0 00-25.91 19.45 193.455 193.455 0 0066.28 55.8 189.77 189.77 0 0087.13 20.89c98 0 179.13-74 190.39-169l28.83-.03z'
					fill='#110BE0'
				/>
				<path
					d='M373.2 76.68a193.323 193.323 0 00-66.28-55.79A189.75 189.75 0 00219.83 0C121.94 0 40.96 73.73 29.48 168.58l-29.46.08 45.64 63.32 45-63.58-28.49.08C73.45 91.6 139.83 32.39 219.83 32.39a157.588 157.588 0 0172.37 17.35 160.871 160.871 0 0155.12 46.39 16.221 16.221 0 004.688 4.386 16.192 16.192 0 0018.232-.835 16.194 16.194 0 006.337-10.873 16.206 16.206 0 00-3.357-12.128h-.02z'
					fill='#110BE0'
				/>
			</g>
			<defs>
				<clipPath id='clip0_1186_688'>
					<path fill='#fff' d='M0 0H439.05V383.49H0z' />
				</clipPath>
			</defs>
		</svg>
	)
}
